import { useTheme } from "@mui/material";

function BoatLineDetailsSvg({
	showBoatAndSea = true,
	showBuoy = false,
}: {
	showBoatAndSea?: boolean;
	showBuoy?: boolean;
}) {
	const showSignal = showBoatAndSea && showBuoy;
	const theme = useTheme();
	return (
		<svg
			viewBox="0 0 1200 70"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={{
				marginLeft: -30,
				marginRight: -30,
			}}
		>
			{showBuoy && (
				<>
					<path
						d="M157.65 84.3828C155.73 64.1828 141.37 51.7928 141.37 51.7928V46.0328L152.57 36.4128H169.38L180.58 46.0328V51.7928C180.58 51.7928 166.22 64.1828 164.3 84.3828H157.65Z"
						stroke={theme.palette.primary.main}
						strokeWidth={1.5}
					/>
					<path d="M141.68 46.0328H180.9" stroke={theme.palette.primary.main} strokeWidth={1.5} />
					<path d="M141.36 51.8028H180.64" stroke={theme.palette.primary.main} strokeWidth={1.5} />
					<path
						d="M157.65 84.3828C155.73 64.1828 141.37 51.7928 141.37 51.7928V46.0328L152.57 36.4128H169.38L180.58 46.0328V51.7928C180.58 51.7928 166.22 64.1828 164.3 84.3828H157.65Z"
						stroke={theme.palette.primary.main}
						strokeWidth={1.5}
					/>
					<path d="M141.68 46.0328H180.9" stroke={theme.palette.primary.main} strokeWidth={1.5} />
				</>
			)}
			{showBoatAndSea && (
				<g>
					<g data-name="boat" fill="none" stroke={theme.palette.primary.main} strokeWidth={1.5}>
						<path d="M0 52.0128H1200" stroke={theme.palette.primary.main} strokeWidth={1.5} />
						<path
							d="M64.42 51.8028H96C95.8789 51.1417 95.8789 50.464 96 49.8028C96.22 49.2328 97.85 46.4628 97.85 46.4628V44.6628H92.65V43.1328L94 40.4028H94.8L94.58 39.0828H83.31V47.5828H74L70.87 41.6828H70.17L69.09 47.5828H64.25L64.42 51.8028Z"
							stroke={theme.palette.primary.main}
							strokeWidth={1.5}
						/>
						<path d="M85.86 30.0328V39.0728" stroke={theme.palette.primary.main} strokeWidth={1.5} />
						<path d="M85.71 36.5428H82.74" stroke={theme.palette.primary.main} strokeWidth={1.5} />
						<path d="M87.65 31.9028H84.68" stroke={theme.palette.primary.main} strokeWidth={1.5} />
					</g>
				</g>
			)}
			{showSignal && (
				<g data-name="signal-lines">
					<path
						d="M150.36 25.7528C151.724 24.3868 153.343 23.303 155.126 22.5635C156.909 21.8241 158.82 21.4435 160.75 21.4435C162.68 21.4435 164.591 21.8241 166.374 22.5635C168.157 23.303 169.776 24.3868 171.14 25.7528V25.7528"
						stroke={theme.palette.primary.main}
						strokeWidth={1.5}
					/>
					<path
						d="M143.67 19.0728C148.201 14.5442 154.344 12.0002 160.75 12.0002C167.156 12.0002 173.299 14.5442 177.83 19.0728"
						stroke={theme.palette.primary.main}
						strokeWidth={1.5}
					/>
					<path
						d="M135.93 11.2828C142.516 4.69874 151.447 1 160.76 1C170.073 1 179.004 4.69874 185.59 11.2828"
						stroke={theme.palette.primary.main}
						strokeWidth={1.5}
					/>
				</g>
			)}
		</svg>
	);
}

export default BoatLineDetailsSvg;
